export * from './aptitudes.d';
export * from './assessmentSettings.d';
export * from './crm.d';
export * from './evaluee.d';
export * from './helpers.d';
export * from './interests.d';
export * from './jobResult.d';
export * from './manager.d';
export * from './payment.d';
export * from './portal.d';
export * from './process-queue.d';
export * from './register.d';
export * from './report.d';
export * from './reportOptions.d';
export * from './surveyResult.d';
export * from './tokens.d';
export * from './user.d';
export * from './workgroups.d';
export * from './occupations.d';